import React from 'react'
import { Box, Typography } from '@mui/material'
import palette from '../../../theme/palette'
import { OWNERS } from './constants'

/* Small presentational cells shared by the attribution page, the side panel and the Non-ABD list. */

export const sectionTitleSx = { fontSize: 10, fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 1 }

export function OwnerChip({ owner, dense = false }) {
  const o = OWNERS[owner || 'NONE']
  return (
    <Box>
      <Box component='span' sx={{
        display: 'inline-block', px: 1, py: 0.25, borderRadius: '4px', fontSize: dense ? 11 : 12, fontWeight: 700,
        color: o.color, bgcolor: o.bg, border: `1px solid ${owner ? o.bg : palette.error.light}`, whiteSpace: 'nowrap',
      }}>
        {o.short}
      </Box>
    </Box>
  )
}

/** "+3d past EDD" (undelivered, red) or "+3d late" (delivered, amber). */
export function LateTag({ breachType, lateDays }) {
  if (!lateDays) return null
  const undelivered = breachType === 'U'
  return (
    <Typography component='span' sx={{ fontSize: 11, fontWeight: 700, color: undelivered ? palette.error.dark : palette.warning.darker }}>
      +{lateDays}d {undelivered ? 'past EDD' : 'late'}
    </Typography>
  )
}

export function Dash() {
  return <Typography component='span' sx={{ color: 'text.disabled' }}>—</Typography>
}

/* ── Compact form styles, measured from the artifact (labels above, 40px inputs, 13px text) ── */
export const flabSx = { fontSize: 10, fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.5px', lineHeight: '13px', mb: 0.75 }
export const hintSx = { fontSize: 11, color: 'text.secondary', lineHeight: 1.5, mt: 0.5 }
export const inputSx = {
  '& .MuiInputBase-root': { fontSize: 13, borderRadius: '6px', bgcolor: 'background.paper' },
  '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 40 },
  '& .MuiInputBase-input::placeholder': { fontSize: 13 },
  '& .MuiFormHelperText-root': { mx: 0, fontSize: 11 },
}

/** Label above + control + hint/error below, the artifact's `.fg` block. */
export function FormField({ label, required, hint, error, children }) {
  return (
    <Box>
      {label && <Typography component='div' sx={flabSx}>{label}{required && <Box component='span' sx={{ color: 'error.main' }}> *</Box>}</Typography>}
      {children}
      {(error || hint) && <Typography sx={{ ...hintSx, color: error ? 'error.main' : 'text.secondary' }}>{error || hint}</Typography>}
    </Box>
  )
}
